// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__hvqaj","paymentContainer":"PaymentPage_paymentContainer__29DEI"};